if($('.medialniVystup').length){
    $(document).ready(function(){
        $.ajax({
            url: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vS-ZkAoB-5WCLIUPBfpbAHayGw_rqYfz6vruic6HC8Hz9GF5xQhehwb0nHBZn_bD9fj1w2BGL-j8yeX/pub?gid=2034056460&single=true&output=csv',
            dataType: 'text',
            success: function(data) {
                var rows = data.split("\n");
                rows.shift();
                $.each(rows, function(index, row) {
                    var columns = row.split(",");
                    var imageUrl = columns[0].trim();
                    var linkUrl = columns[1].trim();
                    var position = columns[2].trim();
                    var className = (position === "left") ? "left" : "right";
                    var div = `
                        <div class="${className}">
                            <a href="${linkUrl}" target="_blank"><img src="${imageUrl}" alt="Media preview"></a>
                        </div>
                    `;
                    $('.medialniVystup').append(div);
                });
            }
        });
    });
    
}